import styled from 'styled-components';

export const Btn = styled.button`
    width: auto;
    height: 50px;
    padding: 0 35px;

    background-color: #536DFE;
    font-size: 15px;
    color: white;

    border: none; /* 테두리 제거 */
    border-radius: 5px; /* 모서리 둥글게 */
    cursor: pointer; /* 버튼에 마우스 올릴 때 포인터 커서 */

    &:hover {
        background-color: #4154d0; /* 호버 시 색상 변경 */
    }
`;
